import { getFilenameFromContentDisposition } from "@msys/common";

export function getNativeDownloadFileName(
  headers: Record<string, string>,
  fallbackFileName: string
): string {
  const contentDisposition = Object.entries(headers).find(
    ([name]) => name.toLowerCase() === "content-disposition"
  )?.[1];
  const fileName = getFilenameFromContentDisposition(contentDisposition)
    ?.replace(/[/\\]/g, "-")
    .trim();

  return fileName ? fileName : fallbackFileName;
}
